export default "__VITE_ASSET__c219f887__$_?component__"